export default "__VITE_ASSET__CwEqXOsr__"